var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { IconButton } from "@brushfire/ui";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import Constants from "../../../../../data/constants";
import { getSeats } from "../../../../../data/api";
import useGroupData from "../../../../../hooks/useGroupData";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useZoom } from "../../../../../hooks/useZoom";
import { useSeatCode } from "../../../../../hooks/useSeatCode";
var ASTVenue = function (_a) {
    var _b, _c;
    var sections = _a.sections, eventData = _a.eventData, setTargetSection = _a.setTargetSection, setSeats = _a.setSeats, setLoadingSeats = _a.setLoadingSeats;
    var _d = __read(useState(), 2), svgMap = _d[0], setSvgMap = _d[1];
    var _e = __read(useState(1), 2), venueScale = _e[0], setVenueScale = _e[1];
    var push = useWidgetHistory().push;
    var groupId = useGroupData((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : 0).groupId;
    var search = useLocation().search.toLowerCase();
    var accessKey = (_c = new URLSearchParams(search).get("access")) !== null && _c !== void 0 ? _c : "";
    var seatCode = useSeatCode().seatCode;
    var isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    var zoomState = useZoom();
    var getSeatsLocal = function (section) {
        var _a;
        return getSeats((_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _a !== void 0 ? _a : 0, section, null, accessKey, null, groupId !== null && groupId !== void 0 ? groupId : null, seatCode);
    };
    useEffect(function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        window.setSection = function (section) {
            setTargetSection(section);
        };
        var isTouchEnabled = "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            navigator.msMaxTouchPoints > 0;
        setSvgMap(isMobile || isTouchEnabled
            ? eventData === null || eventData === void 0 ? void 0 : eventData.venueImage
            : eventData === null || eventData === void 0 ? void 0 : eventData.venueImage.replaceAll("data-section=", "onmouseover='window.setSection(this)' onmouseout='window.setSection(null)' data-section="));
    }, [eventData === null || eventData === void 0 ? void 0 : eventData.venueImage]);
    var handleMapClick = function (evt) {
        var _a;
        evt.stopPropagation();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        var target = evt.target.closest(".venue-map [data-section]");
        if (target && !target.classList.contains("section-soldout")) {
            if (target.dataset.section) {
                if ((_a = sections.find(function (s) { return s.name === target.dataset.section; })) === null || _a === void 0 ? void 0 : _a.isAssigned) {
                    setLoadingSeats(true);
                    getSeatsLocal(target.dataset.section).then(function (_a) {
                        var data = _a.data;
                        setSeats(data);
                        setLoadingSeats(false);
                        push("".concat(Constants.Routes.section
                            .replace(":clientKey", eventData.clientKey)
                            .replace(":urlKey", eventData.urlKey)
                            .replace(":eventNumber", eventData.eventNumber.toString())
                            .replace(":section", target.dataset.section)).concat(seatCode ? "?seatcode=".concat(seatCode) : ""));
                    });
                }
                else {
                    push("".concat(Constants.Routes.section
                        .replace(":clientKey", eventData.clientKey)
                        .replace(":urlKey", eventData.urlKey)
                        .replace(":eventNumber", eventData.eventNumber.toString())
                        .replace(":section", target.dataset.section)).concat(seatCode ? "?seatcode=".concat(seatCode) : ""));
                }
            }
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        var linktarget = evt.target.closest("a[href='#']");
        if (linktarget) {
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "d-flex flex-row b-bottom m-bottom" }, { children: [_jsx(IconButton, { onClick: zoomState.zoomOut, icon: "search-minus", classes: "m-right", ariaLabel: "Zoom Out", disabled: zoomState.scale === zoomState.bounds.lower }), _jsx(IconButton, { onClick: zoomState.zoomIn, icon: "search-plus", classes: "m-right", ariaLabel: "Zoom In", disabled: zoomState.scale === zoomState.bounds.upper })] })), svgMap && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "venue-map" }, { children: _jsx("div", { style: zoomState.styles, className: "venue-map-svg", onClick: handleMapClick, dangerouslySetInnerHTML: { __html: svgMap } }) })) }))] }));
};
export default ASTVenue;
